import React from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import EditCalendarIcon from '@mui/icons-material/EditCalendar'
import { IconButton, Tooltip } from '@mui/material'
import { intl } from '../../../../i18n'
import {
  isProductBacklogItemRow,
  ProductBacklogItemRow,
  ProductBacklogRow,
} from '../productBacklog'

interface Props extends ICellRendererParams<ProductBacklogRow> {
  openSprintAdjustmentDialog?: (row: ProductBacklogItemRow) => void
}

export const SprintAdjustmentActionCellRenderer = ({
  data,
  openSprintAdjustmentDialog,
}: Props) => {
  if (!data || !isProductBacklogItemRow(data)) {
    return <></>
  }

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    if (openSprintAdjustmentDialog) {
      openSprintAdjustmentDialog(data)
    }
  }

  return (
    <div className="sevend-ag-cell-detail">
      <Tooltip
        title={intl.formatMessage({
          id: 'productBacklog.sprintInteractiveAdjustment.title',
        })}
      >
        <IconButton size="small" onClick={handleClick}>
          <EditCalendarIcon fontSize="medium" />
        </IconButton>
      </Tooltip>
    </div>
  )
}
